export * from './common.service';
import { CommonService } from './common.service';
export * from './maskingSetting.service';
import { MaskingSettingService } from './maskingSetting.service';
export const APIS = [CommonService, MaskingSettingService];
